module.exports = __webpack_public_path__ + "img/037-jamaica.393232d9.svg";